const OBSOLESCENCIA = '1'
const DETERIORO = '2'
const PERDIDA = '3'
const ROBO = '4'
const VENTA = '5'
const DONACION = '6'
const DESTRUCCION = '7'
const OTRO = '99'

const __dictionary = {
  [OBSOLESCENCIA]: { id: OBSOLESCENCIA, nombre: 'OBSOLESCENCIA' },
  [DETERIORO]: { id: DETERIORO, nombre: 'DETERIORO' },
  [PERDIDA]: { id: PERDIDA, nombre: 'PÉRDIDA' },
  [ROBO]: { id: ROBO, nombre: 'ROBO' },
  [VENTA]: { id: VENTA, nombre: 'VENTA' },
  [DONACION]: { id: DONACION, nombre: 'DONACIÓN' },
  [DESTRUCCION]: { id: DESTRUCCION, nombre: 'DESTRUCCIÓN' },
  [OTRO]: { id: OTRO, nombre: 'OTRO' }
}

const __array = Object.values(__dictionary)

export default Object.freeze({
  OBSOLESCENCIA,
  DETERIORO,
  PERDIDA,
  ROBO,
  VENTA,
  DONACION,
  DESTRUCCION,
  OTRO,
  __dictionary,
  __array
})
